import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  onClick?: () => void;
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  onClick,
  className = ''
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-lg transition-all duration-200';
  const variants = {
    primary: 'bg-emerald-500 text-white hover:bg-emerald-600 shadow-sm hover:shadow-md',
    secondary: 'bg-orange-500 text-white hover:bg-orange-600 shadow-sm hover:shadow-md',
    outline: 'border-2 border-emerald-500 text-emerald-600 hover:bg-emerald-50'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} className={classes} target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'noopener noreferrer' : undefined} data-id="element-24">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={classes} data-id="element-25">
      {children}
    </button>;
}